export const GRANTED = 'granted';
export const DEFAULT = 'default';
export const DENIED = 'denied';
